module.exports = __webpack_public_path__ + "img/video.png";